<script setup>
import AgencyConfirmCancel from "./AgencyConfirmCancel.vue";
import AgencyOptimiserStatistics from "./AgencyOptimiserStatistics.vue";
import {computed, onMounted} from "vue";
import {useStore} from "vuex";

const props = defineProps({
  organisationId: {
    type: Number,
    required: true,
  },
  websitesWithPublishedChanges: {
    type: Array,
    required: true,
  },
  cancellationReasons: {
    type: Array,
    required: true,
  },
  errors: {
    type: Array,
    default: () => {}
  },
  isPackage: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const store = useStore()
const step = computed(() => store.getters['agencyCancellation/currentStep'])

onMounted(() => {
  if (props.websitesWithPublishedChanges.length === 0) {
    store.dispatch('agencyCancellation/nextStep')
  }
  store.dispatch('agencyCancellation/setOrganisationId', props.organisationId)
  store.dispatch('agencyCancellation/setWebsitesWithPublishedChanges', props.websitesWithPublishedChanges)
  store.dispatch('agencyCancellation/setCancellationReasons', props.cancellationReasons)
  store.dispatch('agencyCancellation/setWebsitesWithPublishedChanges', props.websitesWithPublishedChanges)
  if (props.isPackage) {
    store.dispatch('agencyCancellation/setIsPackage', true);
  }
})

</script>

<template>
  <div class="tailwind">
    <div class="tw-m-auto tw-max-w-default-container tw-rounded-xl tw-bg-white tw-p-8 tw-text-black">
      <AgencyOptimiserStatistics
        v-if="step === 1"
      />
      <AgencyConfirmCancel
        v-if="step === 2"
        :errors="errors"
      />
    </div>
  </div>
</template>
